import React, { useEffect, useRef } from 'react';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css';
import cloudBackupImg1 from '../../../../assets/services/disaster/ManagedBackup/disaster.png'; // Adjust path as needed

const DisasterSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];

    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-text" ref={textRef}>
          <h1>Rapid and Simple Disaster Recovery Service</h1>
          <p>
            Synectiks delivers a modern disaster recovery solution capable of securely spinning up full production environments in minutes—without requiring additional hardware. A single unified portal manages both backup and disaster recovery (DR), enabling multi‑cloud failover and helping service providers meet strict SLAs without exceeding budget. Fail over to a clean recovery point to prevent ransomware reinfection. Choose from multiple cloud failover targets and easily manage recovery infrastructure on‑premises or in hybrid environments. You can automate runbooks, testing, and failover to the Disaster Recovery Cloud, ensuring seamless recovery during DR events.           </p>
        </div>
        <div className="end-user-image" ref={imageRef}>
          <img src={cloudBackupImg1} alt="Cloud Backup Illustration" />
        </div>
      </div>
    </section>
  );
};

export default DisasterSection;
